import api from "../../Hooks/axiosApi";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const insertPropertyService = (data: any) => {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
            if (value instanceof File) {
                // If it's a file, append it directly
                formData.append(key, value);
            } else {
                // Convert non-file values to string
                formData.append(key, String(value));
            }
        }
    });

    return api.post('/api/Property/InsertProperty', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

// PUT: Update an existing property by propertyId
export const updatePropertyService = ({ propertyId, data }: { propertyId: any; data: any }) => {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
            if (value instanceof File) {
                formData.append(key, value);
            } else {
                formData.append(key, String(value));
            }
        }
    });

    return api.put(`/api/Property/UpdateProperty/${propertyId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};


// POST: Soft delete a property by propertyId
// export const softDeletePropertyService = (propertyId: any) => {
//     return api.post(`/api/Property/SoftDeleteProperty/${propertyId}`);
// };

export const softDeletePropertyService = (propertyIds: number[]) => {
    return api.post('/api/Property/SoftDeleteProperties', propertyIds);
};


// GET: Retrieve properties by clientId
export const getPropertiesByIdService = (clientId: any) => {
    return api.get(`/api/Property/GetPropertiesById/${clientId}`);
};



// Function to upload property brochure
export const uploadPropertyBrochure = async (formData: FormData) => {
    try {
        const response = await axios.post(`${BASE_URL}/api/Property/upload-brochure`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error uploading brochure:', error);
        throw error;
    }
};

// Function to download property data as Excel
export const downloadPropertyExcel = async (supplierId?: number | null) => {
    try {
        const url = supplierId
            ? `${BASE_URL}/api/Property/downloadexcel_propertydata?supplierId=${supplierId}`
            : `${BASE_URL}/api/Property/downloadexcel_propertydata?supplierId=0`;

        const response = await axios.get(url, {
            responseType: 'blob',
        });

        return response;
    } catch (error) {
        console.error('Error downloading Excel:', error);
        throw error;
    }
};